import React from 'react';
import { components } from 'react-select';
import { SelectPlaceholderProps } from './types';

function Placeholder<T = string>({
  children,
  renderPlaceholderContent,
  selectProps,
  ...rest
}: SelectPlaceholderProps<T>): ReactComponentReturnType {
  const { placeholder } = selectProps;

  // react-select's components.Placeholder generic requires its option
  // type to extend OptionTypeBase, but T here is intentionally generic
  // so the wrapper works for any caller's option shape. Cast through
  // unknown to bypass the structural-narrowing — runtime behaviour is
  // unchanged, only the surrounding TS bound differs.
  const passthrough = { selectProps, ...rest } as unknown as React.ComponentProps<
    typeof components.Placeholder
  >;

  return (
    <components.Placeholder {...passthrough}>
      {(renderPlaceholderContent &&
        placeholder &&
        typeof placeholder === 'string' &&
        renderPlaceholderContent(placeholder)) ||
        children}
    </components.Placeholder>
  );
}

export default Placeholder;
